module.exports = __webpack_public_path__ + "media/images/step_optimisation-952ecc81ff7a36bf11256113c153859f.svg";